module.exports = __webpack_public_path__ + "assets/images/couch-01.63e8cc25b34ff6db98137c0cd0d01ea3.svg";